import { IPointsConfig } from '@/api/points';
import store, { useAppSelector } from '@/stores';


export interface IPointsInfo {
  needCheckPoints: boolean;
  modulePoints: number;
  currentPoints: number;
  pointConfig?: IPointsConfig;
}

const generateData = (configs: {
  isVip: boolean;
  /** user points */
  points: number;
  moduleConfig?: IPointsConfig;
}): IPointsInfo => {
  // return {
  //   needCheckPoints: false,
  //   modulePoints: 0,
  //   currentPOints: 0,
  // };
  return {
    needCheckPoints: !!(!configs.isVip && configs.moduleConfig && configs.moduleConfig.num > 0),
    modulePoints: configs.moduleConfig?.num || 0,
    currentPoints: configs.points,
    pointConfig: configs.moduleConfig,
  };
};

/**
 * 根据特定模块key，获取相应点数
 * @param s
 * @returns
 */

export const getModulePoints = (moduleKey: number): IPointsInfo => {
  const state = store.getState();
  const m = state.points.modulePoints.find(ele => ele.id === moduleKey);
  const isVip = state.user.userPermission.isVip;
  const points = state.user.userPermission.points;

  return generateData({
    isVip,
    points,
    moduleConfig: m
  });
};

export const useModulePoints = (moduleKey: number): IPointsInfo => {
  const m = useAppSelector(state => state.points.modulePoints.find(ele => ele.id === moduleKey));
  const isVip = useAppSelector(state => state.user.userPermission.isVip);
  const points = useAppSelector(state => state.user.userPermission.points);

  return generateData({
    isVip,
    points,
    moduleConfig: m
  });
};

/**
 * 根据type 获取需金币
 */
export const getModulePointByType = (type: number, subType: number): IPointsInfo => {
  const state = store.getState();
  const m = state.points.modulePoints.find((ele) => ele.type === type && ele.sub_type === subType);
  const isVip = state.user.userPermission.isVip;
  const points = state.user.userPermission.points;

  return generateData({
    isVip,
    points,
    moduleConfig: m
  });

};

/**
 * 根据type 获取需金币
 */
export const useModulePointsByType = (type: number, subType: number): IPointsInfo => {
  const m = useAppSelector(state => state.points.modulePoints.find((ele) => ele.type === type && ele.sub_type === subType));
  const isVip = useAppSelector(state => state.user.userPermission.isVip);
  const points = useAppSelector(state => state.user.userPermission.points);

  return generateData({
    isVip,
    points,
    moduleConfig: m
  });

};
